import React from 'react';
import { Link } from 'react-router-dom';
import { withRouter } from "react-router";
import { Menu, Tooltip } from 'antd';
import _ from "lodash"
import languageFile from "../../../public/languages/Translation";
import urlConfig from '../../config/index';
import './style.scss';
var cookie = require("../../utils/cookie");

var moment = require("moment");

class SideBar extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
        }
        this.activeRoute = this.activeRoute.bind(this)
    }

    activeRoute(routeName) {
        let style = {
            color: this.props.color.activeIcon,
            backgroundColor: this.props.color.activeTabList,
            transition: " all 0.5s ease-in-out"
        }
        let normalStyle={
            color: this.props.color.tabIcon,
            backgroundColor: this.props.color.sidebarBackground,
        }
        return this.props.location.pathname.indexOf(routeName) === 0 ?
            style :
            normalStyle ;
    }
    activeStyle=()=>{
        let activestyle = {
            color: this.props.color.activeIcon,
            backgroundColor: this.props.color.activeTabList,
            transition: " all 0.5s ease-in-out"
        }
        return activestyle
    }
    dynamicBorderColor=()=>{
        let border={borderColor:this.props.color.sidebarBorder +" transparent "+this.props.color.sidebarTransparency+" transparent"}
        return border;
    }

    domainLogoLoaded = (event) => {
		const target = (event && event.target) || {};
		if(target.style) {
			target.style.opacity = 1;
		}
	}

	domainLogoNotLoaded = (event) => {
		const target = (event && event.target) || {};
		if(target.style) {
			target.style.opacity = 0;
		}
	}

    render() { 
        var urlName = urlConfig.urlName;
        return (<div className="sidebar-preview" style={{backgroundColor: this.props.color.sidebarBackground}}>
            <Tooltip title={languageFile[localStorage.getItem('language')]["Profiles"]} placement="right">
                <div className="logo" style={{ backgroundColor: this.props.color.logoBackground }}>
                    <span className="logo-minimised">
                        <img onLoad={this.domainLogoLoaded} onError={this.domainLogoNotLoaded} src={`/images/${urlName}/logo-icon.png`} />
                    </span>
                    <span className="logo-expanded">
                        <img onLoad={this.domainLogoLoaded} onError={this.domainLogoNotLoaded}  src={`/images/${urlName}/logo-text.png`} />
                    </span>
                </div>
            </Tooltip>
            <ul className="sidebar-menu">
                <li key="1" style={this.dynamicBorderColor()}>
                    <Tooltip title={languageFile[localStorage.getItem('language')]["10723"]} placement="right">
                        <Link style={this.activeStyle()}>
                            <span className="nav-icon">
                                <i className="fa fa-bar-chart" aria-hidden="true"></i>
                            </span>
                            <span className="nav-label"> {languageFile[localStorage.getItem('language')]["10723"]}</span>
                        </Link>
                    </Tooltip>
                </li>
                <li key="8" style={this.dynamicBorderColor()}>
                    <Tooltip title={
                        languageFile[localStorage.getItem('language')]["21671"]
                    } placement="right">
                        <Link style={this.activeRoute('/insights')}>
                        {/* <Link style={this.activeRoute('/performance')}> */}
                            <span className="nav-icon">

                                <i className="fa fa-area-chart" aria-hidden="true"></i>
                            </span>
                            {/* <span className="nav-label"> {
                            languageFile[localStorage.getItem('language')]["21671"]
                            // 'Performance'
                            }</span> */}
                        </Link>
                    </Tooltip>

                </li>
                {/* <li key="2" style={this.dynamicBorderColor()}>
                    <Tooltip title={languageFile[localStorage.getItem('language')]["12350"]} placement="right">
                        <Link style={this.activeRoute('/localperformance')}>
                            <span className="nav-icon">
                                <i className="fa fa-tachometer" aria-hidden="true"></i>
                            </span>
                            <span className="nav-label"> {languageFile[localStorage.getItem('language')]["12350"]}</span>
                        </Link>
                    </Tooltip>
                </li> */}
                <li key="3" style={this.dynamicBorderColor()}>
                    <Tooltip title={languageFile[localStorage.getItem('language')]["13583"]} placement="right">
                        <Link style={this.activeRoute('/reviews')}>
                            <span className="nav-icon">
                                <i className="fa fa-comment-o" aria-hidden="true"></i>
                            </span>
                            <span className="nav-label"> {languageFile[localStorage.getItem('language')]["13574"]}</span>
                        </Link>
                    </Tooltip>
                </li>
                <li key="4" style={this.dynamicBorderColor()}>
                    <Tooltip title={languageFile[localStorage.getItem('language')]["12532"]} placement="right">
                        <Link style={this.activeRoute('/managelocations')}>
                            <span className="nav-icon">
                                <i className="fa fa-map-marker" aria-hidden="true"></i>
                            </span>
                            <span className="nav-label"> {languageFile[localStorage.getItem('language')]["12365"]}</span>
                        </Link>
                    </Tooltip>
                </li>
                <li key="10" style={this.dynamicBorderColor()}>
                    <Tooltip title="Manage Locations in Bulk" placement="right">
                        <Link style={this.activeRoute('/locationbulkupdate')}>
                           <span className="nav-icon">
                                <i className="fa fa-map" aria-hidden="true"></i><em>Beta</em>
                            </span>
                            <span className="nav-label">{languageFile[localStorage.getItem('language')]["12532"]}</span>
                        </Link>
                    </Tooltip>
                </li>           
                <li key="5" className="setting">
                    <Tooltip title={languageFile[localStorage.getItem('language')]["13825"]} placement="right">
                        <Link style={this.activeRoute('/settings')}>
                            <span className="nav-icon">
                                <i className="fa fa-wrench" aria-hidden="true"></i>
                            </span>
                            <span className="nav-label"> {languageFile[localStorage.getItem('language')]["13825"]}</span>
                        </Link>
                    </Tooltip>
                </li>
            </ul>
        </div >
        )
    }
}

export default withRouter(SideBar);